var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", [
        _c("div", { staticClass: "margin-top-title" }, [
          _c("b", [_vm._v("Camadas de Bloqueio")]),
          _vm.intersecaoComCamadaDeBloqueio
            ? _c(
                "div",
                { staticClass: "margin-top-subtitle" },
                [
                  _c("span", [
                    _vm._v(
                      "Este processo contém interseção com áreas fora de jurisdição do " +
                        _vm._s(_vm.orgao) +
                        " para regularização fundiária."
                    )
                  ]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.arquivos,
                        stripe: "stripe",
                        "show-header": false
                      }
                    },
                    [
                      _c("el-table-column", { attrs: { prop: "nome" } }),
                      _c("el-table-column", {
                        attrs: { align: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizar(
                                            _vm.numeroProcesso,
                                            scope.row.tipo
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "eye", size: "lg" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4040756989
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _c("div", { staticClass: "margin-top-subtitle" }, [
                _c("span", [
                  _vm._v(
                    "Este processo não contém interseção com áreas fora de jurisdição do " +
                      _vm._s(_vm.orgao) +
                      " para regularização fundiária."
                  )
                ])
              ])
        ]),
        _vm.possuiAlerta && !_vm.isPara
          ? _c("div", { staticClass: "margin-top-title" }, [
              _c("b", [_vm._v("Camadas de Alerta")]),
              _c(
                "div",
                { staticClass: "margin-top-subtitle" },
                [
                  _c("span", [
                    _vm._v(
                      "Este processo contém interseção com camadas de alerta."
                    )
                  ]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.arquivosAlerta,
                        stripe: "stripe",
                        "show-header": false
                      }
                    },
                    [
                      _c("el-table-column", { attrs: { prop: "nome" } }),
                      _c("el-table-column", {
                        attrs: { align: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizar(
                                            _vm.numeroProcesso,
                                            scope.row.tipo
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "eye", size: "lg" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4040756989
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.isPara
          ? _c("div", { staticClass: "margin-top-title" }, [
              _c("b", [_vm._v("Monitoramento ambiental")]),
              _vm.intersecaoComMonitoramentoAmbiental
                ? _c(
                    "div",
                    { staticClass: "margin-top-subtitle" },
                    [
                      !_vm.statusIconeAlerta.includes(
                        _vm.monitoramento.cruzamentoAmbiental.dados
                          .statusAmbiental
                      )
                        ? _c("i", {
                            staticClass:
                              "fal fa fa-exclamation-triangle cor-warning"
                          })
                        : _vm._e(),
                      _vm.monitoramento.cruzamentoAmbiental.dados.camadas.length
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 10 } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "margin-top-title" },
                                    [
                                      _c("div", [
                                        _c("span", [
                                          _vm._v("Uso e cobertura do solo")
                                        ])
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Selecione o ano"
                                          },
                                          model: {
                                            value: _vm.anoSelecionado,
                                            callback: function($$v) {
                                              _vm.anoSelecionado = $$v
                                            },
                                            expression: "anoSelecionado"
                                          }
                                        },
                                        _vm._l(
                                          _vm.monitoramento.cruzamentoAmbiental
                                            .dados.camadas[0].urls,
                                          function(camada) {
                                            return _c("el-option", {
                                              key: camada.ano,
                                              attrs: {
                                                label: camada.ano,
                                                value: camada.ano
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.monitoramento.cruzamentoAmbiental.dados
                                      .camadas[0].urls,
                                    function(camada) {
                                      return _c("img", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              camada.ano === _vm.anoSelecionado,
                                            expression:
                                              "camada.ano === anoSelecionado"
                                          }
                                        ],
                                        staticClass: "img-mapa",
                                        attrs: {
                                          src: camada.url,
                                          width: "400px"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 10 } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "margin-top-title" },
                                    [
                                      _c("div", [
                                        _c("span", [_vm._v("Desmatamento")])
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Selecione o ano"
                                          },
                                          model: {
                                            value:
                                              _vm.anoSelecionadoMonitoramento,
                                            callback: function($$v) {
                                              _vm.anoSelecionadoMonitoramento = $$v
                                            },
                                            expression:
                                              "anoSelecionadoMonitoramento"
                                          }
                                        },
                                        _vm._l(
                                          _vm.monitoramento.cruzamentoAmbiental
                                            .dados.camadas[1].urls,
                                          function(camada) {
                                            return _c("el-option", {
                                              key: camada.ano,
                                              attrs: {
                                                label: camada.ano,
                                                value: camada.ano
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.monitoramento.cruzamentoAmbiental.dados
                                      .camadas[1].urls,
                                    function(camada) {
                                      return _c("img", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              camada.ano ===
                                              _vm.anoSelecionadoMonitoramento,
                                            expression:
                                              "camada.ano === anoSelecionadoMonitoramento"
                                          }
                                        ],
                                        staticClass: "img-mapa",
                                        attrs: {
                                          src: camada.url,
                                          width: "400px"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              ),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("img", {
                                  staticClass: "img-legenda",
                                  attrs: {
                                    src: _vm.monitoramento.urlLegenda,
                                    width: "150px"
                                  }
                                })
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                [
                  !_vm.isLaudoMonitoramento
                    ? _c("span", [_vm._v("Mapa e Laudo ainda não processados")])
                    : _vm._e(),
                  _vm.isLaudoMonitoramento
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.arquivosLaudo,
                            stripe: "stripe",
                            "show-header": false
                          }
                        },
                        [
                          _c("el-table-column", { attrs: { prop: "nome" } }),
                          _c("el-table-column", {
                            attrs: { align: "right" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              return _vm.visualizar(
                                                _vm.numeroProcesso,
                                                scope.row.tipo
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "eye", size: "lg" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4040756989
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.isPara
          ? _c(
              "div",
              { staticClass: "margin-top-title" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("b", [_vm._v("Uso e cobertura do solo")])
                    ]),
                    _c("el-col", { attrs: { span: 24 } }, [
                      _vm.isMapaUsoECobertura
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.arquivoCobertura,
                                    stripe: "stripe",
                                    "show-header": false
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "nome" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "right" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { size: "mini" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.visualizar(
                                                        _vm.numeroProcesso,
                                                        scope.row.tipo
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "eye",
                                                      size: "lg"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4040756989
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c("div", [
                            _c("span", [
                              _vm._v(
                                "Mapa de uso e cobertura do solo ainda em processamento."
                              )
                            ])
                          ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d806b05a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d806b05a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppVisualizarMonitoramentoAreaTab.vue
// module id = null
// module chunks = 